"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const AddData = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _react.default.createElement("path", {
  d: "M8.28 14.316H6.4v-2.527h1.672c.096-.606.296-1.17.576-1.684H6.4V7.58h3.2v1.297c.464-.455 1-.783 1.6-1.002v-.295h3.2v.295c.6.219 1.136.547 1.6 1.002V1.684C16 .758 15.28 0 14.4 0H1.6C.72 0 0 .758 0 1.684v12.632C0 15.242.72 16 1.6 16h7.632a4.75 4.75 0 01-.952-1.684zM11.2 3.368h3.2v2.527h-3.2V3.368zm-4.8 0h3.2v2.527H6.4V3.368zM4.8 14.316H1.6v-2.527h3.2v2.527zm0-4.21H1.6V7.578h3.2v2.526zm0-4.211H1.6V3.368h3.2v2.527zM12 9.263h1.6v2.527H16v1.684h-2.4V16H12v-2.526H9.6V11.79H12V9.262z",
  className: "fill"
}));

var _default = AddData;
exports.default = _default;